export const navbar_profile_validation_methods = {
  only_digits(event) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
    if (allowedKeys.includes(event.key)) return;
    if (!/[0-9/]/.test(event.key)) {
      event.preventDefault();
    }
  },

  validate_registration() {
    this.new_company.registration_number = this.new_company.registration_number.slice(0, 14);
    this.registration_error = this.is_valid_registration_number()
      ? ''
      : 'Please enter a valid registration number';
  },

  is_valid_registration_number() {
    return /^\d{4}\/\d{6}\/\d{2}$/.test(this.new_company.registration_number);
  },

  on_registration_input(e) {
    const raw = e?.target?.value ?? '';
    this.new_company.registration_number = this.format_registration_number(raw);
    this.validate_registration();
  },

  format_registration_number(value) {
    const digits = String(value).replace(/\D/g, '').slice(0, 12);
    const parts = [
      digits.slice(0, 4),
      digits.slice(4, 10),
      digits.slice(10, 12),
    ].filter(Boolean);
    return parts.join('/');
  },

  validate_vat() {
    this.new_company.vat_number = this.new_company.vat_number.slice(0, 10);
    this.vat_error = /^\d{10}$/.test(this.new_company.vat_number)
      ? ''
      : 'Please enter a valid VAT number (10 digits)';
  },

  on_email_input(e) {
    const value = (e?.target?.value ?? '').trim();
    this.user.email = value.toLowerCase();
    this.email_touched = true;
    this.email_error = this.is_email_valid ? '' : 'Please enter a valid email address.';
  },

  validate_before_save() {
    if (this.is_email_valid) return true;

    this.email_touched = true;
    this.email_error = 'Please enter a valid email address.';
    this.$notyf.info('Invalid email. Please fix and try again.');
    return false;
  },

  validate_sa_id_number(id_number) {
    if (!/^\d{13}$/.test(id_number)) return false;
    if (!this.is_valid_sa_id_birthdate(id_number)) return false;

    return this.luhn_algorithm(id_number);
  },

  is_valid_sa_id_birthdate(id_number) {
    const birth_parts = this.sa_id_birth_parts(id_number);
    const dob = new Date(
      Reflect.get(birth_parts, 'full_year'),
      Reflect.get(birth_parts, 'month') - 1,
      Reflect.get(birth_parts, 'day')
    );

    return dob.getFullYear() === Reflect.get(birth_parts, 'full_year')
      && dob.getMonth() === Reflect.get(birth_parts, 'month') - 1
      && dob.getDate() === Reflect.get(birth_parts, 'day');
  },

  sa_id_birth_parts(id_number) {
    const yy = id_number.substring(0, 2);
    const month = parseInt(id_number.substring(2, 4), 10);
    const day = parseInt(id_number.substring(4, 6), 10);
    const current_year = new Date().getFullYear().toString().substr(-2);
    const century = parseInt(yy, 10) <= parseInt(current_year, 10) ? '20' : '19';

    return ({
      full_year: parseInt(century + yy, 10),
      month,
      day,
    });
  },

  luhn_algorithm(id_number) {
    let sum = 0;
    let is_even = false;

    for (let i = id_number.length - 1; i >= 0; i--) {
      const digit = this.luhn_digit(id_number.charAt(i), is_even);
      sum += digit;
      is_even = !is_even;
    }
    return sum % 10 === 0;
  },

  luhn_digit(raw_digit, is_even) {
    let digit = parseInt(raw_digit, 10);
    if (!is_even) return digit;

    digit *= 2;
    return digit > 9 ? digit - 9 : digit;
  },

  validate_id_number() {
    this.user_profile.id_number = this.user_profile.id_number.replace(/\D/g, '').slice(0, 13);
    this.id_number_error = this.get_id_number_error();
  },

  get_id_number_error() {
    if (!this.user_profile.id_number || this.user_profile.id_number.trim() === '') {
      return 'ID number is required';
    }
    return this.validate_sa_id_number(this.user_profile.id_number) ? null : 'Invalid ID number';
  },
};
